
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './Myhero2.css';
// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import img2 from '../Assets/16 (1) (1).jpg'
import img3 from '../Assets/15 (1) (1) (1).jpg'
import img4 from '../Assets/17 (1).jpg'
import img6 from '../Assets/19 (2).jpg'
import img7 from '../Assets/20 (1).jpg'
import img8 from '../Assets/25 (1).jpg'

const Myhero2 = () => {
  return (
    <>
    <Swiper
      spaceBetween={30}
      centeredSlides={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      navigation={true}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper"
    >
      <SwiperSlide><img className='imghero' src={img2} alt="" /></SwiperSlide>
      <SwiperSlide><img className='imghero' src={img3} alt="" /></SwiperSlide>
      <SwiperSlide><img className='imghero' src={img4} alt="" /></SwiperSlide>
      <SwiperSlide><img className='imghero' src={img6} alt="" /></SwiperSlide>
      <SwiperSlide><img className='imghero' src={img7} alt="" /></SwiperSlide>
      <SwiperSlide><img className='imghero' src={img8} alt="" /></SwiperSlide>
    </Swiper>
  </>
  )
}

export default Myhero2